/* import __COLOCATED_TEMPLATE__ from './watch-overview-video.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();